/**
 * Determine location priority based on available sources
 * Priority: JWT session > localStorage > portal default
 * @param {Object} session - User session with location_id
 * @param {string} localStorageStoreView - Store view ID from localStorage
 * @param {Object} portal - Portal object with default_location
 * @returns {number|null} - Selected location ID or null
 */
export const getStoreViewPriority = (session, localStorageStoreView, portal) => {
  // Priority 1: JWT session location (user's saved preference)
  if (session?.location_id) return Number(session.location_id)

  // Priority 2: localStorage location (previously selected)
  if (localStorageStoreView && !isNaN(Number(localStorageStoreView))) return Number(localStorageStoreView)

  // Priority 3: Portal default location
  if (portal?.default_location?.id) return Number(portal.default_location.id)

  return null
}

/**
 * Validate if user has access to the specified location
 * @param {Object} user - Current user object
 * @param {string|number} storeViewId - Store view ID to validate
 * @param {Array} availableStoreViews - User's available store views
 * @returns {boolean} - Whether user has access to store view
 */
export const validateUserStoreViewAccess = (user, storeViewId, availableStoreViews) => {
  // If user is not logged in, allow access to any location
  if (!user?.id) return true

  // If user has no location restrictions, allow access
  if (!availableStoreViews || availableStoreViews.length === 0) return true

  // Check if location is in user's available locations
  return availableStoreViews.some(storeView => storeView.id?.toString() === storeViewId?.toString())
}
